export const GET_JOB_CARDS_STATED = 'GET_JOB_CARDS_STATED';
export const GET_JOB_CARDS = 'GET_JOB_CARDS';
export const GET_JOB_CARDS_ENDED = 'GET_JOB_CARDS_ENDED';
export const ADD_JOB_CARD_STATED = 'ADD_JOB_CARD_STARTED';
export const ADD_JOB_CARD = 'ADD_JOB_CARD';
export const ADD_JOB_CARD_ENDED = 'ADD_JOB_CARD_ENDED';
export const EDIT_JOB_CARD_STATED = 'EDIT_JOB_CARD_STATED';
export const EDIT_JOB_CARD = 'EDIT_JOB_CARD';
export const EDIT_JOB_CARD_ENDED = 'EDIT_JOB_CARD_ENDED';
export const GET_JOB_CARD = 'GET_JOB_CARD';
export const GET_JOB_CARD_STATED = 'GET_JOB_CARD_STATED';
export const GET_JOB_CARD_ENDED = 'GET_JOB_CARD_ENDED';
export const RESET_JOB_CARD = 'RESET_JOB_CARD';
export const ERROR_JOB_CARD = 'ERROR_JOB_CARD';
export const GET_ALL_JOB_CARDS_STATED = 'GET_ALL_JOB_CARDS_STATED';
export const GET_ALL_JOB_CARDS = 'GET_ALL_JOB_CARDS';
export const GET_ALL_JOB_CARDS_ENDED = 'GET_ALL_JOB_CARDS_ENDED';
